import { LOCAL_STORAGE_KEYS } from '@/lib/local-storage-keys'

// Pre-load white-label from Zustand cache before React initializes
if (typeof window !== 'undefined') {
  try {
    const whiteLabelStorage = localStorage.getItem(
      LOCAL_STORAGE_KEYS.WHITE_LABEL,
    )

    if (whiteLabelStorage) {
      const { state } = JSON.parse(whiteLabelStorage)
      const CACHE_DURATION = 1000 * 60 * 60 // 1 hour
      const isExpired =
        state.lastFetched && Date.now() - state.lastFetched > CACHE_DURATION

      if (!isExpired && state.isWhiteLabel) {
        // Apply cached white-label immediately before React loads
        // Title is managed by usePageTitle hook, so we only set favicon here
        if (state.faviconUrl) {
          const link = document.createElement('link')
          link.rel = 'icon'
          link.type = 'image/png'
          link.href = state.faviconUrl
          document.head.appendChild(link)
        }
      }
    }
  } catch (error) {
    // Ignore cache errors
  }
}

// Initialize theme from localStorage (Zustand persist format)
if (typeof window !== 'undefined') {
  try {
    const storedData = localStorage.getItem(LOCAL_STORAGE_KEYS.THEME)

    if (storedData) {
      // Parse Zustand persisted state
      const { state } = JSON.parse(storedData)
      const theme = state?.theme

      if (theme === 'dark') {
        document.documentElement.classList.add('dark')
        document.documentElement.classList.remove('light')
      } else {
        document.documentElement.classList.add('light')
        document.documentElement.classList.remove('dark')
      }
    } else {
      // First load: apply system preference and it will be saved by Zustand
      const prefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)',
      ).matches
      if (prefersDark) {
        document.documentElement.classList.add('dark')
        document.documentElement.classList.remove('light')
      } else {
        document.documentElement.classList.add('light')
        document.documentElement.classList.remove('dark')
      }
    }
  } catch (error) {
    // Fallback to system preference on error
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)',
    ).matches
    if (prefersDark) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.add('light')
    }
  }
}
